export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Od"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["do"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["znaków"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niedozwolona wartość"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole wymagane"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprawdź pola"])}
}